import { Box, SxProps, Theme, Typography } from "@mui/material";

interface BaseStatusBoxProps<T extends string> {
  additionalBoxSx?: (arg0: T, arg1: Theme) => SxProps<Theme>;
  additionalTypographySx?: (arg0: T, arg1: Theme) => SxProps<Theme>;
  getStatusColorFn: (arg0: T, arg1: Theme) => string;
  isInvert?: boolean;
  status: T;
  statusStringKeyMap: Record<T, string>;
}

const BaseStatusBox = <T extends string>({ 
  additionalBoxSx,
  additionalTypographySx,
  getStatusColorFn, 
  isInvert,
  status, 
  statusStringKeyMap, 
}: BaseStatusBoxProps<T>) => {

  const defaultBoxSx: SxProps<Theme> = (theme: Theme) => ({
    backgroundColor: isInvert ? "white" : getStatusColorFn(status, theme),
    borderRadius: "0.25rem",
    color: isInvert ? getStatusColorFn(status, theme) : "white",
    pl: 1,
    pr: 1,
    boxShadow: 1,
    ...(isInvert && { 
      border: 1, 
      borderColor: getStatusColorFn(status, theme) 
    }),
    display: "inline-block",
  });

  const defaultTypographySx: SxProps<Theme> = (theme: Theme) => ({
  });

  const boxSx: SxProps<Theme> = (theme: Theme) => ({ 
    ...defaultBoxSx(theme), 
    ...(additionalBoxSx && additionalBoxSx(status, theme)) 
  });
  const typographySx: SxProps<Theme> = (theme: Theme) => ({
    ...defaultTypographySx(theme),
    ...(additionalTypographySx && additionalTypographySx(status, theme)),
  });

  return (
    <Box 
      component={"span"}
      sx={boxSx}
    >
      <Typography sx={typographySx}>
        {statusStringKeyMap[status]}
      </Typography>
    </Box>
  );
    
}

export default BaseStatusBox;